import {
  createRouter,
  createWebHistory,
} from "vue-router";

import { websiteRoutes } from "@/router/websiteRoutes";
import { adminRoutes } from "@/router/adminRoutes";


const finalRoutes = [
  ...websiteRoutes,
  ...adminRoutes,
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: finalRoutes,
  scrollBehavior(to, from, savedPosition) {
    return new Promise((resolve) => {
      setTimeout(() => {
        if (savedPosition) {
          resolve(savedPosition);
        } else if (to.hash) {
          resolve({ el: to.hash, behavior: "smooth" });
        } else {
          resolve({ left: 0, top: 0 });
        }
      }, 300);
    });
  },
});


export default router;
